<template>
  <div>
      <Header :id="id"></Header>
      <div class="topimg">
        <img :src="banner" alt="">
      </div>
      <div class="info">
        <div class="info2">
          <div class="itit">{{exhibition.exhibitionTitle}}</div>
          <div class="itit2" v-html="exhibition.exhibitionDesc">
            {{exhibition.exhibitionDesc}}
          </div>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>

import Header from "./components/Header";
import Footer from "../components/Footer";

export default {
  name: "About",
  components: {
    Footer,
    Header,
  },
   data() {
    return {
      id: this.$route.params.id,
      exhibition: [],
      banners: [],
      banner: '',
      token: localStorage.token,
    };
  },
  mounted () {
    if (this.token == '') {
      this.$layer.msg('请先登录');
      this.$router.go(-1)
    }
    this.getDetail()
    this.getList()
  },
  methods: {
     // 获取展会详情
    getDetail () {
       this.$common.fetchList('/exhibition/detail/'+this.id, {}).then(data => {
        if (data.code === 200) {
          const result = data.data
          this.exhibition = result
        }
      }).catch(() => {
        // this.$notification.error({
        // message: '错误',
        // description: '请求信息失败，请重试'
        // })
      })
    },
    // 展会官网首页
    getList () { 
       this.$common.fetchList('/exhibition/index?exhibitionId='+this.id, {}).then(data => {
        if (data.code === 200) {
          const result = data.data
          for(const [k, v] of Object.entries(result)) {
            this[k] = v
          }
          this.banner = this.banners[0].mediaUrl
        }
      }).catch(() => {
        // this.$notification.error({
        // message: '错误',
        // description: '请求信息失败，请重试'
        // })
      })
    },
  }
}
</script>

<style lang="less" scoped>
  @import '~@/assets/css/exabout.less';
</style>